'use client';

import { createContext, useContext } from 'react';
import { executeClientVariation } from './execute-client-variation';

export interface FeatureFlagProviderContext {
  innerContext: any;
  featureFlags: any;
}

const featureFlagContext = createContext<FeatureFlagProviderContext>(undefined as any);

export function FeatureFlagsProvider({
  children,
  context,
}: {
  children: React.ReactNode;
  context: FeatureFlagProviderContext;
}) {
  return <featureFlagContext.Provider value={context}>{children}</featureFlagContext.Provider>;
}

class FeatureFlagClient {
  constructor(private readonly _context: FeatureFlagProviderContext) {}

  variation<T = boolean>(key: string): T | false {
    if (typeof window !== 'undefined') {
      executeClientVariation(key, this._context.innerContext);
    }
    return this._context.featureFlags[key] || false;
  }
}

let globalClient: FeatureFlagClient;

export function useFeatureFlags() {
  const context = useContext(featureFlagContext);

  globalClient = globalClient || (globalClient = new FeatureFlagClient(context));

  return globalClient;
}
